// extracted by mini-css-extract-plugin
export default {"button":"SupportFeedbackButton_button__TBnyc","icon":"SupportFeedbackButton_icon__DNq1f","label":"SupportFeedbackButton_label__kTdki","tucked":"SupportFeedbackButton_tucked__k5ZFv"};